import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-card-home',
  templateUrl: './skeleton-card-home.component.html',
  styleUrls: ['./skeleton-card-home.component.scss']
})
export class SkeletonCardHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
